import React from 'react';
import get from 'get-value';
import {TextareaFieldWithValidation} from '../../../../../common/TextareaFieldWithValidation';
import {
    FORM_FIELD_EDITORS_NOTES_AS,
    FORM_LABEL_EDITORS_NOTES_AS,
    FORM_LABEL_EDITORS_NOTES_HISTORY_AS,
} from '../../../../../../constants/formConstants';
import {FormattedDate, FormattedMessage, FormattedTime, injectIntl} from 'react-intl';
import formMessages from '../../../../../../intl/afterSales/formMessages';
import {connect} from 'react-redux';
import ValidFormattedMessage from '../../../../../common/ValidFormattedMessage';
import styled from 'styled-components';
import {getFormInitialValues} from 'redux-form';
import commonMessages from '../../../../../../intl/common/commonMessages';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const EditorsNotesSection = props => {

    const {userRights, readOnly, initialValues} = props;

    const editorsNotes = get(initialValues, 'editorsNotes', []);
    const hasNotes = editorsNotes && editorsNotes.length > 0;
    const canAddNotes = !readOnly && userRights.canAddEditorsNotes;

    const getCreatorData = (message) => {
        const {creatorName, solutionGroup, creatorIpn} = message;
        const solutionGroupName = solutionGroup ? ' ' + solutionGroup.name + ' ' : ' ';
        return `${creatorName}${solutionGroupName}(${creatorIpn})`;
    }

    return (
        <>
            {(hasNotes || canAddNotes) && <>
                <h3 className="text-left mt-4 ml-4">
                    <FormattedMessage {...formMessages.EDITORS_NOTES_SECTION_AS}/>
                </h3>
                <StyledDiv className="border border-secondary bg-white overflow-hidden">
                    {hasNotes && <div>
                        <div className="border-bottom border-bottom-secondary"
                             style={{backgroundColor: '#e9ecef', borderRadius: '5px 5px 0 0'}}>
                            <label className="col-form-label pl-0 font-weight-bold ml-3">
                                <ValidFormattedMessage message={FORM_LABEL_EDITORS_NOTES_HISTORY_AS}
                                                       intlMessages={formMessages}/>
                            </label>
                        </div>
                        {editorsNotes.map((editorsNote, index) =>
                            <div key={index} className="row m-0 align-items-stretch">
                                <div style={{backgroundColor: '#f8f9fa'}}
                                     className="col-sm-12 col-lg-4 flex-column border-bottom">
                                    <div>
                                        <FormattedDate value={new Date(editorsNote.created)}/> <FormattedTime
                                        value={new Date(editorsNote.created)}/>
                                        <span className="font-weight-bold">{' '}
                                            <ValidFormattedMessage message={editorsNote.isDealer ? 'DEALER' : 'EDITOR'}
                                                                   intlMessages={commonMessages}/>
                                        </span>
                                    </div>
                                    <div>
                                        {getCreatorData(editorsNote)}
                                    </div>
                                </div>
                                <div className="col border-bottom" style={{whiteSpace: 'pre-wrap'}}>
                                    {editorsNote.text}
                                </div>
                            </div>
                        )}
                    </div>}
                    {canAddNotes && <div className="col-sm-12 px-4 pb-3 pt-1">
                        <div className="col-sm-12 px-0">
                            <TextareaFieldWithValidation label={formMessages[FORM_LABEL_EDITORS_NOTES_AS]}
                                                         field={FORM_FIELD_EDITORS_NOTES_AS}
                                                         rows={3}/>
                        </div>
                    </div>}
                </StyledDiv>
            </>}
        </>
    );
};

const mapStateToProps = (state, props) => ({
    initialValues: getFormInitialValues(props.form)(state),
});

export default injectIntl(connect(mapStateToProps)(EditorsNotesSection));
